module.exports = __webpack_public_path__ + "fonts/subset-Averta-Regular.4c6dd25.eot";